import { Fragment } from "react";
import FilterableProductTable from "./components/FilterableProductTable";

function App() {
  return (
    <Fragment>
      <FilterableProductTable />
    </Fragment>
  );
}

export default App;
